import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';

import { cn } from '@/lib/utils';

import { TIMEZONES, SUBSCRIBER_LOCAL_TIME, type TimezoneKey } from '../../../constants/scheduling';

export interface TimezoneSelectorProps {
  value?: string;
  onValueChange: (value: string) => void;
  excludeLocal?: boolean;
  className?: string;
  placeholder?: string;
}

export const TimezoneSelector = ({
  value,
  onValueChange,
  excludeLocal,
  className,
  placeholder = 'Select timezone'
}: TimezoneSelectorProps) => {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        className={cn(
          'bg-input rounded-lg cursor-pointer hover:bg-accent/40 hover:text-accent-foreground',
          className
        )}
      >
        <SelectValue placeholder={placeholder}>
          {value ? TIMEZONES[value as TimezoneKey] : null}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {Object.entries(TIMEZONES)
          .filter(([key]) => !excludeLocal || key !== SUBSCRIBER_LOCAL_TIME)
          .map(([key, label]) => (
            <SelectItem key={key} value={key} className="cursor-pointer">
              {label}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};
